import { FC } from 'react';
import { Modal as QcsModal } from '@mui/material';

import { QcsModalBox } from '../../../common/basic/QcsModalBox';
import { SectionHeader } from '../../../common/SectionHeader';
import * as Yup from 'yup';
import { Form } from 'formik';
import { FormikDebounce } from '../../../common/form/FormikDebounce';
import { FormContainer } from '../../../common/form/FormContainer';
import { validations } from '../../../../utils/validations';
import { SubmitButton } from '../../../common/form/SubmitButton';
import { ActivityAutocomplete } from '../../../common/form/ActivityAutocomplete';
import { useInvitation } from './invitationFunctions';
import { invitationService } from '@api/services/services';
import { ActivityRequestDto } from '@api/models/request/invitation/ActivityRequestDto';
import { ShowError } from '../../../ShowError';
import { Input } from '../../../common/form/Input';
import { resources } from '@api/resources';
import { ActivityDto } from '@api/models/activity/ActivityDto';

interface ActivityRequestModalForm {
  activities: ActivityDto[];
  reason?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
}

export const ActivityRequestModal: FC<Props> = ({ open, onClose }) => {
  const { t, invitation, callWithLock } = useInvitation();

  const handleSubmit = async (formData: ActivityRequestModalForm) => {
    await callWithLock(async () => {
      const data: ActivityRequestDto = {
        activities: formData.activities.map((it) => it.id!),
        reason: formData.reason,
      };
      await invitationService.requestActivity(data, { invitationId: invitation.id! });
      onClose();
    });
  };

  return (
    <QcsModal open={open} onClose={onClose}>
      <QcsModalBox>
        <SectionHeader title="activity.requestAddTitle" />
        <FormikDebounce<ActivityRequestModalForm>
          initialValues={{
            activities: [],
            reason: '',
          }}
          validationSchema={Yup.object().shape({
            activities: validations.arrayNotEmpty(t),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormContainer>
              <ActivityAutocomplete
                name="activities"
                label={t('invitation.activity.name')}
                required
                excludeIds={invitation.activities?.map((x) => x.activity?.id ?? '')}
                multiple
                showCertificates
              />
              <Input name="reason" label={t('activity.requestAddReason')} multiline rows={3} fullWidth />
              <ShowError resource={resources.requestActivity} />
              <SubmitButton text={t('invitation.activity.sendRequest')} />
            </FormContainer>
          </Form>
        </FormikDebounce>
      </QcsModalBox>
    </QcsModal>
  );
};
